import { cn } from '../../lib/utils';

export type PayloadViewMode = 'payload' | 'full';

export function PayloadToggle({
  mode,
  onToggle,
}: {
  mode: PayloadViewMode;
  onToggle: (mode: PayloadViewMode) => void;
}) {
  return (
    <div className="inline-flex overflow-hidden rounded-md border border-border/60 text-3xs font-mono">
      <button
        type="button"
        onClick={() => onToggle('payload')}
        className={cn(
          'px-1.5 py-0.5 transition-colors',
          mode === 'payload'
            ? 'bg-muted text-foreground'
            : 'text-muted-foreground hover:text-foreground',
        )}
      >
        Payload
      </button>
      <button
        type="button"
        onClick={() => onToggle('full')}
        className={cn(
          'px-1.5 py-0.5 transition-colors',
          mode === 'full'
            ? 'bg-muted text-foreground'
            : 'text-muted-foreground hover:text-foreground',
        )}
      >
        Full Message
      </button>
    </div>
  );
}
